'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHammerjs = require('react-hammerjs');

var _reactHammerjs2 = _interopRequireDefault(_reactHammerjs);

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./table-row.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventOptions = {
  recognizers: {
    tap: { threshold: 9 },
    press: { threshold: 9 }
  }
};

var TableRow = function TableRow(_ref) {
  var className = _ref.className,
      children = _ref.children,
      loading = _ref.loading,
      dragAndDrop = _ref.dragAndDrop,
      onContextMenu = _ref.onContextMenu,
      onRefsReady = _ref.onRefsReady,
      onRowPress = _ref.onRowPress,
      onRowTap = _ref.onRowTap;
  return _react2.default.createElement(
    _reactHammerjs2.default,
    {
      ref: function ref(_ref2) {
        return _ref2 && onRefsReady && onRefsReady(_ref2.domElement);
      },
      className: (0, _classnames2.default)(className, 'hammerjs-wrapper', 'table__row', loading && 'table-row--loading'),
      onTap: onRowTap,
      onPress: onRowPress,
      options: eventOptions
    },
    _react2.default.createElement(
      'tr',
      _extends({ onContextMenu: onContextMenu }, dragAndDrop),
      children
    )
  );
};

TableRow.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  loading: _propTypes2.default.bool,
  dragAndDrop: _propTypes2.default.object,
  onContextMenu: _propTypes2.default.func,
  onRefsReady: _propTypes2.default.func,
  onRowPress: _propTypes2.default.func,
  onRowTap: _propTypes2.default.func
};

TableRow.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  onContextMenu: function onContextMenu() {
    return null;
  },
  onRefsReady: function onRefsReady() {
    return null;
  },
  onRowPress: function onRowPress() {
    return null;
  },
  onRowTap: function onRowTap() {
    return null;
  }
};

exports.default = TableRow;